import React, { useCallback } from "react";
import { useWrapup } from "./wrapupcontext";
import { NavbarDivider } from "@blueprintjs/core";
import { useDialogManager } from "@/components/global/dialog";
import WrapupDialog from "./dialog";
import SButton from "@/components/global/sbutton";

export default function WrapupNavbarItem(): React.ReactNode {
    const { addDialog } = useDialogManager();
    const { hasWrapup } = useWrapup();

    const onClick = useCallback(
        () => addDialog(
            (<WrapupDialog isOpen={true} onClose={() => { }} />),
        ),
        [addDialog],
    );

    if (!hasWrapup) {
        return null;
    }

    return <React.Fragment>
        <NavbarDivider />
        <SButton
            onClick={onClick}
            minimal={true}
        >
            🎁 WRAPUP
        </SButton>
    </React.Fragment>;

}
